import { atom } from "recoil"

const homeState = atom({
  key: 'home',
  default: {
    menu: 'chatting',
    fontSize: 12,
  }
});

export default homeState;